<template>
  <div class="order-card">
    <div>
      <span class="order-name text-capitalize">{{ name }}</span>
      <span class="order-cost">${{ Number(price).toLocaleString() }}</span>
    </div>
    <div>
      <span class="order-points">Store Manager</span>
      <span class="order-price"
        >({{ Math.floor(Number(points)).toLocaleString() }} points)</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "price", "points"],
  name: "store",
};
</script>

<style lang="scss" scoped>
.order-card {
  width: 100%;
  margin: auto;
  border-bottom: 1px solid #c1c8cf;
  padding-bottom: 10px;
  box-sizing: border-box;
}

.order-name {
  display: inline-block;
  margin: 10px 0 5px 0px;
  font-style: normal;
  align-items: center;
  letter-spacing: 0.1px;
  color: #45505B;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}
.order-cost {
  float: right;
  margin: 10px 0 5px 0px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #687888;
}

.order-points {
  display: inline-block;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #687888;
}
.order-price {
  float: right;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: var(--success);
}
.store-address {
  display: block;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #333;
}
@media (max-width: 600px) {
   .order-card {
     padding:10px;
   }
}
</style>


